import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Zoom } from 'react-reveal';
import { useNavigate } from 'react-router-dom';
import './MySelfCart.css'

const MySelfCart = ({ pd }) => {
    const { title, logo, customPathLocation } = pd;

    const navigate = useNavigate();

    const handleDetailsOUtline = () => {
        navigate(`/${customPathLocation}`)
    }

    return (
        <div className='col-lg-3 col-md-6 col-sm-6 col-12'>
            <Zoom>
                <div className="myfont shadow-lg" onClick={handleDetailsOUtline}>
                    <p><FontAwesomeIcon icon={logo} className='me-3 text-primary' size='2x' /></p>
                    <h4 className='fs-4 fw-bold'>{title}</h4>
                </div>
            </Zoom>
        </div>
    );
};

export default MySelfCart;